module.exports = __webpack_public_path__ + "img/1.a47b7223.png";